module.exports = __webpack_public_path__ + "img/lookbook_5_right.b3354d5d.png";